import { LiteralHeadersTableTitles, RouteTypes } from 'consts';
import FilterListPractice from 'containers/filterListPractice';
import Header from 'containers/Header';
import Table from 'containers/Table';
import { useList } from 'hooks/list';
import { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  getInfoUserProfile,
  postUpdateUltimoAviso,
  setModalDraftType,
  setMsgSubmit,
  setPracticaReclamadaSeleccionada,
  setPracticaRechazadaSeleccionada,
  setPracticaValidadaSeleccionada,
  setLoading,
} from 'store/app/actions';
import {
  makeSelectInfoUserProfileSelected,
  makeSelectModalDraftType,
  makeSelectMsgSubmit,
} from 'store/app/selectors';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import {
  getPracticas,
  getPracticasCount,
  getPracticasExcel,
  setPracticasCount2,

} from 'store/practicas/actions';
import {
  makeSelectFechaMaximaPractica,
  makeSelectFechaMinimaPractica,
  makeSelectPracticasList,
  makeSelectPracticasListCount,
} from 'store/practicas/selectors';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { getFirstDayOfTheMonthDate, getTodayFinishDate } from 'utils/dates-validators';
import { hasAccess } from 'utils/listUtils';
import {
  parseDate,
  parsePracticeStatus,
  parseTime,
} from 'utils/parsePractices';
import { getDefaultStatus } from 'utils/practiceUtils';
import { perfilesAlumno, userProfile } from 'utils/profilesIndex';
import './practice-list.scss';

const selectors: any = createStructuredSelector({
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  practicas: makeSelectPracticasList(),
  practicasCount: makeSelectPracticasListCount(),
  fechaMinimaPractica: makeSelectFechaMinimaPractica(),
  fechaMaximaPractica: makeSelectFechaMaximaPractica(),
  infoUserProfile: makeSelectInfoUserProfileSelected(),
} as any);

const options =
  '[{"label": "Fecha inicio de menor a mayor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "asc"},"active": "true"},{"label": "Fecha inicio de mayor a menor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de mayor a menor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de menor a mayor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "asc"},"active": "false"}]';

export const listPracticasConstant = 'Listado de prácticas';

const buildStationParagraph = (code: any, description: any): string => {
  if (!code && !description) {
    return '-';
  }

  const stationCode = code && code !== null ? code : '';
  const stationDescription = description && description !== null ? description : '';

  return stationCode + ' - ' + stationDescription;
};

const buildUserProfileText = (item: any): string => {
  if (item.usuario_nombre_perfil) {
    return item.usuario_nombre_perfil;
  }

  const tipoUsuario =
    item.usuario_perfil_parsed === 'ALUMNO'
      ? ' - ' + item.usuario_tipo_ie_parsed
      : '';

  return item.usuario_perfil_parsed + tipoUsuario;
};

const buildPracticeHeaders = (
  canSeeClaimCheckField: boolean,
  canSeeRejectCheckField: boolean,
  canSeeInstructor: boolean,
  canSeeUserInfo: boolean,
  practicasCount: number
): { headers: any[]; headerExcel: any[] } => {
  const commonFields1 = [
    { text: LiteralHeadersTableTitles.CURSO }
  ];

  const commonFields1_1 = [
    {
      text: 'Inicio  Serv.',
      orderBy: true,
      ariaLabelIcon: 'Icono de ordenar',
    },
    {
      text: 'Fin  Serv.',
      orderBy: true,
      ariaLabelIcon: 'Icono de ordenar',
    },
    { text: LiteralHeadersTableTitles.MINUTOS },
    { text: LiteralHeadersTableTitles.TIPO_PRACTICA },
    { text: LiteralHeadersTableTitles.TREN },
  ];

  const horaPuestaDisp = [
    { text: LiteralHeadersTableTitles.HORA_PUESTA_DISP },
  ];

  const jornadaInfoFields = [
    { text: LiteralHeadersTableTitles.FECHA_INI_JORNADA },
    { text: LiteralHeadersTableTitles.FECHA_FIN_JORNADA },
    { text: LiteralHeadersTableTitles.HORA_INI_JORNADA },
    { text: LiteralHeadersTableTitles.HORA_FIN_JORNADA },
    { text: LiteralHeadersTableTitles.TOTAL_JORNADA },
  ];

  const estacionesInfoFields = [
    { text: LiteralHeadersTableTitles.ESTACION_INICIO },
    { text: LiteralHeadersTableTitles.ESTACION_FIN },
  ];

  const userInfoFields = [
    { text: LiteralHeadersTableTitles.ALUMNO },
    { text: LiteralHeadersTableTitles.NOMBRE_PERFIL },
  ];
  const userInfoFieldsExcel = [
    { text: LiteralHeadersTableTitles.ID_ALUMNO },
    { text: LiteralHeadersTableTitles.ALUMNO_NOMBRE },
    { text: LiteralHeadersTableTitles.ALUMNO_TOOLTIP },
    { text: LiteralHeadersTableTitles.NOMBRE_PERFIL },
    { text: LiteralHeadersTableTitles.TIPO_USUARIO },
    { text: LiteralHeadersTableTitles.TIPO_EXTERNO },
  ];

  const instructorFields = [
    { text: LiteralHeadersTableTitles.INSTRUCTOR },
  ];
  const instructorFieldsExcel = [
    { text: LiteralHeadersTableTitles.ID_INSTRUCTOR },
    { text: LiteralHeadersTableTitles.INSTRUCTOR_NOMBRE },
    { text: LiteralHeadersTableTitles.INSTRUCTOR_TOOLTIP },
  ];

  const commonFields2: any = [
    { text: LiteralHeadersTableTitles.ESTADO, hideResponsive: false },
    {
      text: LiteralHeadersTableTitles.VER,
      hideResponsive: true,
    },
  ];

  if ((canSeeClaimCheckField || canSeeRejectCheckField || !canSeeInstructor) && practicasCount !== 0) {
    commonFields2.splice(1, 0, {
      text: '',
      checkRow: 'false',
      hideResponsive: false,
    });
  }

  let headers: any[] = [...commonFields1, ...horaPuestaDisp, ...commonFields1_1];
  let headerExcel: any[] = [...commonFields1, ...jornadaInfoFields, ...horaPuestaDisp, ...commonFields1_1, ...estacionesInfoFields];
  if (canSeeInstructor) {
    headers = [...headers, ...instructorFields];
    headerExcel = [...headerExcel, ...instructorFieldsExcel];
  }

  if (canSeeUserInfo) {
    headers = [...headers, ...userInfoFields];
    headerExcel = [...headerExcel, ...userInfoFieldsExcel];
  }

  return {
    headers: [...headers, ...commonFields2],
    headerExcel: [...headerExcel, ...commonFields2],
  };
};

const buildPracticeCommonFields = (item: any, accessToAlumns: boolean): any[] => {
  const link = accessToAlumns ? '/listado-alumnos/' + item.ID_CURSO : '';

  return [
    {
      text: item.ID_CURSO,
      urlLink: link,
    },
    {
      text:
        item.HORA_INI_PUESTA_DISP !== null ? parseTime(item.HORA_INI_PUESTA_DISP) : ' - ',
    },
    {
      text:
        parseDate(item.FECHA_INI_SERVICIO) +
        ' ' +
        parseTime(item.HORA_INI_SERVICIO),
    },
    {
      text:
        parseDate(item.FECHA_FIN_SERVICIO) +
        ' ' +
        parseTime(item.HORA_FIN_SERVICIO),
    },
    { text: item.MIN_PRACTICA },
    {
      text: item.ID_TIPO_PRACTICA !== '' ? item.DESC_PRACTICA : '',
    },
    {
      tooltip: [
        {
          title: 'NºTren: ',
        },
        {
          paragraph: item.NUM_TREN ? item.NUM_TREN : '-',
        },
        {
          title: 'Estación Inicio: ',
        },
        {
          paragraph: buildStationParagraph(
            item.COD_ESTACION_INI,
            item.DESC_ESTACION_INI
          ),
        },
        {
          title: 'Estación Fin: ',
        },
        {
          paragraph: buildStationParagraph(
            item.COD_ESTACION_FIN,
            item.DESC_ESTACION_FIN
          ),
        },
      ],
    },
  ];
};

const buildPracticeInfoUser = (item: any): any[] => [
  item.ID_ALUMNO
    ? {
      text: item.ID_ALUMNO + ' - ' + item.nombre_usuario_parsed,
      //Tooltip directamente con la matricula del instructor (Se deja por si acaso)
      tooltip: [
        {
          title: 'Observaciones alumno: ',
        },
        {
          paragraph:
            item.OBSERVACIONES_ALUMNO !== null
              ? item.OBSERVACIONES_ALUMNO
              : 'No hay observaciones del alumno',
        },
      ],
      className: item.ID_ALUMNO ? 'position_icon' : '',
    }
    : {
      text: '',
    },
  {
    text: buildUserProfileText(item),
  },
];

const buildPracticeInstructorField = (item: any): any[] => [
  item.ID_INSTRUCTOR
    ? {
      text: item.ID_INSTRUCTOR
        ? item.ID_INSTRUCTOR + ' - ' + item.NOMBRE_INSTRUCTOR
        : '',
      tooltip: [
        {
          title: 'Observaciones instructor: ',
        },
        {
          paragraph:
            item.OBSERVACIONES_INSTRUCTOR !== null
              ? item.OBSERVACIONES_INSTRUCTOR
              : ' No hay observaciones del instructor',
        },
      ],
      className: item.ID_ALUMNO ? 'position_icon' : '',
    }
    : {
      text: '',
    },
];

const buildPracticeCommonFields2 = (
  item: any,
  canSeeClaimCheckField: boolean,
  canSeeRejectCheckField: boolean,
  canSeeInstructor: boolean,
  practicasCount: number
): any[] => {
  const commonFields2: any = [
    {
      text: parsePracticeStatus(item.ID_EST_PRACTICA),
    },
    {
      urlIcon: RouteTypes.DETAIL.replace(':id', String(item?.ID_PRACTICA)),
      ariaLabelIcon: 'Abrir modal',
      label: item.ID_PRACTICA,
    },
  ];

  if (
    (canSeeClaimCheckField || canSeeRejectCheckField || !canSeeInstructor) &&
    practicasCount !== 0
  ) {
    commonFields2.splice(1, 0, {
      checkRow: 'false',
      label: item.ID_PRACTICA,
      data: item.ID_PRACTICA,
    });
  }

  return commonFields2;
};

interface BuildPracticeParsedOptions {
  accessToAlumns: boolean;
  canSeeInstructor: boolean;
  canSeeAlumnInfo: boolean;
  canSeeUserInfo: boolean;
  canSeeClaimCheckField: boolean;
  canSeeRejectCheckField: boolean;
  practicasCount: number;
}

const buildPracticeParsed = (
  item: any,
  options: BuildPracticeParsedOptions
): any => {
  const {
    accessToAlumns,
    canSeeInstructor,
    canSeeAlumnInfo,
    canSeeUserInfo,
    canSeeClaimCheckField,
    canSeeRejectCheckField,
    practicasCount,
  } = options;

  let data: any[] = [...buildPracticeCommonFields(item, accessToAlumns)];

  if (canSeeInstructor || canSeeAlumnInfo) {
    data = [
      ...data,
      ...buildPracticeInstructorField(item),
      //...instructorFieldName,
      //...instructorFieldToolTip,
    ];
  }

  if (canSeeUserInfo) {
    data = [...data, ...buildPracticeInfoUser(item)];// ...infoUserName, ...inforUserToolTip, ...infoUserPerfilName];
  }

  data = [
    ...data,
    ...buildPracticeCommonFields2(
      item,
      canSeeClaimCheckField,
      canSeeRejectCheckField,
      canSeeInstructor,
      practicasCount
    ),
  ];

  return {
    table: [data],
  };
};

const Home = (): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [checkedPractice] = useState<any[]>([]);
  const [hideClaimButton, setHideClaimButton] = useState(false);
  const [hideRejectButton, setHideRejectButton] = useState(false);
  const [hideValidButton, setHideValidButton] = useState(false);
  const [openInit, setOpenInit] = useState(false);
  const [modalType, setModalType] = useState('');
  const [msgModal, setMsgModal] = useState('');

  const [itemsOnLeftByProfile, setitemsOnLeftByProfile] = useState(5);

  const defaultLinks = [
    {
      label: listPracticasConstant,
      link: RouteTypes.HOME,
      textHelp: listPracticasConstant,
      active: true,
    },
  ];

  const links = defaultLinks;

  const {
    access_token,
    msgSubmit,
    modalDraftType,
    profileActive,
    practicas,
    practicasCount,
    fechaMinimaPractica,
    fechaMaximaPractica,
    infoUserProfile,
  } = useSelector<any, any>(selectors);
  const [list] = useState(true);
  const redirect = (e: any) => {
    history.push(e.detail);
  };

  const getSelectedFechaHasta = (): any => {
    return perfilesAlumno.includes(profileActive?.ID_PERFIL)
      ? fechaMaximaPractica?.FECHA_TIMESTAMP ?? getTodayFinishDate()
      : getTodayFinishDate();
  };

  const defaultEmptyFilter = {
    alumnos: '',
    ascDesc: '',
    cursos: '',
    elemFin: 10,
    elemInicio: 0,
    estados: profileActive?.ID_PERFIL.startsWith('1') ? 'PC,BO' : 'RE,PV',
    fechaFin: getSelectedFechaHasta(),
    fechaInicio: getFirstDayOfTheMonthDate(),
    instructores: '',
    orden: '',
    sociedades: '',
    savedValues: false,
    lastProfile: profileActive?.ID_PERFIL,
  };

  const [initFilter, setInitFilter] = useState(
    window.location.pathname === RouteTypes.HOME
      ? JSON.parse(
        sessionStorage.getItem(`savedFilter-${window.location.pathname}`) ??
        JSON.stringify(defaultEmptyFilter)
      )
      : defaultEmptyFilter
  );

  useEffect(() => {
    const savedFilterHome = JSON.parse(
      sessionStorage.getItem(`savedFilter-${window.location.pathname}`) ??
      JSON.stringify(defaultEmptyFilter)
    );

    if (
      savedFilterHome.savedValues === true &&
      savedFilterHome.lastProfile === profileActive?.ID_PERFIL
    ) {
      setInitFilter(savedFilterHome);
    } else if (
      savedFilterHome.savedValues === false ||
      savedFilterHome.lastProfile !== profileActive?.ID_PERFIL
    ) {
      defaultEmptyFilter.fechaFin = getSelectedFechaHasta();
      setInitFilter(defaultEmptyFilter);
    }
  }, [profileActive, fechaMaximaPractica]);

  /** PROFILE ACCESS */
  const canSeeAlumnExt = hasAccess(profileActive, [
    userProfile.alumno.extBecario,
    userProfile.alumno.extAspirante,
    userProfile.alumno.extMaquinista,
  ]);

  const canSeeInstructor = !hasAccess(profileActive, [
    userProfile.instructor
  ]);

  const canSeeValidButton = !hasAccess(profileActive, [
    userProfile.instructor,
    userProfile.administrador,
    //userProfile.gestor,
    userProfile.formador
  ]);

  const canSeeClaimCheckField = hasAccess(profileActive, [
    userProfile.gestor,
    userProfile.administrador,
    userProfile.formador,
  ]);

  const canSeeRejectCheckField = hasAccess(profileActive, [
    userProfile.gestor,
    userProfile.administrador,
    userProfile.formador,
  ]);

  const canSeeUserInfo = hasAccess(profileActive, [
    userProfile.gestor,
    userProfile.administrador,
    userProfile.instructor,
    userProfile.formador,
    userProfile.supervisor,
    userProfile.visualizador,
  ]);

  const accessToAlumns = hasAccess(profileActive, [
    userProfile.formador,
    userProfile.gestor,
    userProfile.administrador,
    userProfile.supervisor,
    userProfile.visualizador
  ]);

  const canSeeAlumnInfo = hasAccess(profileActive, [
    userProfile.alumno.extBecario,
    userProfile.alumno.extAspirante,
    userProfile.alumno.extMaquinista,
    userProfile.alumno.intBecario,
    userProfile.alumno.intMaquinista,
    userProfile.formador,
    userProfile.gestor,
    userProfile.administrador,
    userProfile.supervisor,
    userProfile.visualizador,
  ]);
  /** end section */

  useEffect(() => {
    document.body.addEventListener('mousemove', () => {
      const aux = document.querySelector(
        'div.ui-lateral-menu > button.ui-lateral-menu__menu-button'
      );
      const isContained = aux?.classList.contains(
        'ui-lateral-menu__menu-button--open'
      );
      if (!isContained) {
        const uls = document.querySelectorAll(
          'div.ui-lateral-menu ul.ui-lateral-menu__sublink-list--open'
        );
        uls.forEach((ul) => {
          ul.classList.remove('ui-lateral-menu__sublink-list--open');
        });
      }
    });
  }, []);

  useEffect(() => {
    // Change filter when params change
    const filter = getDefaultStatus(profileActive, {
      ...initFilter,
      alumnos: initFilter.alumnos,
      cursos: initFilter.cursos,
    });

    setInitFilter({ ...filter, fechaFin: getSelectedFechaHasta() });
  }, [profileActive, fechaMaximaPractica]);

  const currentProfileId = useRef(null);

  const {
    filterRef,
    data,
    setData,
    headers,
    setHeaders,
    headerExcel,
    setheaderExcel,
    handleFilterTable,
    handleFilterChange,
  } = useList(
    { ...initFilter },
    [],
    {
      action: (filter) => {
        sessionStorage.setItem(
          `savedFilter-${window.location.pathname}`,
          JSON.stringify({ ...filter, savedValues: true })
        );
        return dispatch(getPracticas(filter));
      },
      headerToAPIMap: {
        'Inicio  Serv.': 'FECHA_INI_SERVICIO',
        'Fin  Serv.': 'FECHA_FIN_SERVICIO',
      },
    },
    (filter) => {
      dispatch(setPracticasCount2(0));
      dispatch(getPracticas(filter));
      dispatch(getPracticasCount(filter));
    },
    async () => {
      dispatch(setLoading(true));
      await new Promise(resolve => setTimeout(resolve, 90));
      dispatch(setLoading(false));
    }
  );


  const handleSelectAll = (data) => {
    const newData = data.map((cell) => {
      return cell.data;
    });

    if (canSeeClaimCheckField) {
      dispatch(setPracticaReclamadaSeleccionada(newData.toString()));
    }
    if (canSeeRejectCheckField) {
      dispatch(setPracticaRechazadaSeleccionada(newData.toString()));
    }
    
     if (!canSeeValidButton) {
      dispatch(setPracticaValidadaSeleccionada(newData.toString()));
    }
  };

  const handleSelectPractica = (e: any) => {
    const practiceSelected: any = checkedPractice;
    if (e.detail.checked === true) {
      practiceSelected.push(e.detail.data);
    } else {
      const pos = practiceSelected.indexOf(e.detail.data);
      practiceSelected.splice(pos, 1);
    }
    if (canSeeRejectCheckField) {
      dispatch(setPracticaRechazadaSeleccionada(practiceSelected.toString()));
    }
    if (canSeeClaimCheckField) {
      dispatch(setPracticaReclamadaSeleccionada(practiceSelected.toString()));
    }
    
    if (!canSeeValidButton) {
      dispatch(setPracticaValidadaSeleccionada(practiceSelected.toString()));
    }
  };

  function confirmGoProfile() {
    dispatch(postUpdateUltimoAviso());
    setOpenInit(false);
    setModalType('');
    setMsgModal('');
    setTimeout(() => {
      history.push(RouteTypes.PROFILE);
    }, 500);
  }

  function rejectGoProfile() {
    dispatch(postUpdateUltimoAviso());
    setOpenInit(false);
    setModalType('');
    setMsgModal('');
  }

  useEffect(() => {
    if (!profileActive) {
      return;
    }
    if (canSeeAlumnExt) {
      dispatch(getInfoUserProfile());
    }
    setHideClaimButton(canSeeClaimCheckField);
    setHideRejectButton(canSeeRejectCheckField);
    setHideValidButton(!canSeeValidButton);

    const practiceHeaders = buildPracticeHeaders(
      canSeeClaimCheckField,
      canSeeRejectCheckField,
      canSeeInstructor,
      canSeeUserInfo,
      practicasCount
    );

    setheaderExcel(practiceHeaders.headerExcel);
    setHeaders(practiceHeaders.headers, practiceHeaders.headerExcel);
  }, [practicas, profileActive, practicasCount]);

  useEffect(() => {
    if (!profileActive) {
      return;
    }

    const practicasParsed = practicas.map((item) =>
      buildPracticeParsed(item, {
        accessToAlumns,
        canSeeInstructor,
        canSeeAlumnInfo,
        canSeeUserInfo,
        canSeeClaimCheckField,
        canSeeRejectCheckField,
        practicasCount,
      })
    );

    setData(practicasParsed);
  }, [practicas, profileActive, practicasCount]);

  useEffect(() => {
    const getFechaDesdeListAlumn = (): number => {
      if (filterRef.current.savedValues === false) {
        if (
          filterRef.current.alumnos !== '' &&
          filterRef.current.cursos !== ''
        ) {
          return fechaMinimaPractica?.FECHA_TIMESTAMP?.toString();
        } else {
          return getFirstDayOfTheMonthDate();
        }
      } else {
        return filterRef.current.fechaInicio;
      }
    };

    const profileChange =
      currentProfileId.current !== profileActive?.ID_PERFIL;

    if (profileChange) {
      currentProfileId.current = profileActive?.ID_PERFIL;
      filterRef.current = getDefaultStatus(profileActive, filterRef.current);
      filterRef.current.sociedades = '';
      filterRef.current.fechaInicio = getFechaDesdeListAlumn();
      filterRef.current.fechaFin = getSelectedFechaHasta();
      dispatch(getPracticas(filterRef.current));
      dispatch(getPracticasCount(filterRef.current));
    }
  }, [profileActive, fechaMinimaPractica, fechaMaximaPractica]);


  const handleExportExcel = () => {
    dispatch(
      getPracticasExcel({
        filter: { ...filterRef.current },
        excelConfig: {
          literals: headerExcel,
          profile: profileActive,
        },
      })
    );
  };

  useEffect(() => {
    if (
      profileActive?.ID_PERFIL.startsWith('12') &&
      infoUserProfile.MOSTRAR_AVISO === 'S'
    ) {
      setOpenInit(true);
      setMsgModal(
        'Para un mejor seguimiento por parte de los instructores, formadores, gestores y administradores, es conveniente que suba a su perfil una foto actual para que estos usuarios puedan identificarlo más fácilmente '
      );
      setModalType('confirm');
    } else {
      setModalType('');
      setMsgModal('');
      setOpenInit(false);
    }
  }, [infoUserProfile.MOSTRAR_AVISO]);

  useEffect(() => {
    if (profileActive) {
      switch (profileActive.ID_PERFIL) {
        case '111':
        case '121':
        case '122':
        case '123':
          setitemsOnLeftByProfile(4);
          break;
        case '211':
        case '311':
        case '411':
        case '511':
        case '611':
        case '711':
          setitemsOnLeftByProfile(5);
          break;
      }
    }
  }, [profileActive]);

  useEffect(() => {
    if (!profileActive && fechaMaximaPractica) {
      filterRef.current.fechaFin = getSelectedFechaHasta();
    }
    //solo se ejecuta una vez cuando no hay perfil aqui se establece

  }, [profileActive, fechaMaximaPractica]);

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <>
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">{listPracticasConstant}</h1>
        <FilterListPractice
          handleSubmit={handleFilterChange}
          initValues={initFilter}
        />
        <RfUiModal
          title-modal={msgModal}
          modalConfirmText="Ir al perfil"
          id-modal="modalDraft"
          modal-type={modalType}
          onModalClose={rejectGoProfile}
          onConfirm={confirmGoProfile}
        ></RfUiModal>
        <Table
          openInit={openInit}
          redirect={(e: any) => {
            redirect(e);
          }}
          list={list}
          headers={headers}
          data={data}
          orderMobile={true}
          orderOptions={options}
          dataCount={practicasCount}
          handleFilter={handleFilterTable}
          hideAudit={true}
          itemsOnLeft={itemsOnLeftByProfile}
          hideClaim={!hideClaimButton}
          hideReject={!hideRejectButton}
          hideValid={!hideValidButton}
          showButtonDetail={true}
          handleExportExcel={handleExportExcel}
          handleCheckAll={handleSelectAll}
          handleCheckPractica={handleSelectPractica}
        />
        <RfUiModal
          title-modal={msgSubmit}
          modalConfirmText="Aceptar"
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
          onConfirm={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
        ></RfUiModal>
      </div>
    </>
  );
};

export default Home;
